import TakeAway from '@/models/takeAway';
import { TakeAwayProps } from '@/interfaces/models/order';

export default () => {
  if (Array.isArray(window.axios.defaults.transformResponse)) {
    return window.axios.defaults.transformResponse.concat(({ saved, done }: any): any => {
      return {
        saved: saved.map((receiptProps: TakeAwayProps) => TakeAway.createFromRequest(receiptProps)),
        done: done.map((receiptProps: TakeAwayProps) => TakeAway.createFromRequest(receiptProps))
      };
    });
  }
};
